import { render, staticRenderFns } from "./preview-card.vue?vue&type=template&id=7e949fbc&scoped=true"
import script from "./preview-card.vue?vue&type=script&lang=js"
export * from "./preview-card.vue?vue&type=script&lang=js"
import style0 from "./preview-card.vue?vue&type=style&index=0&id=7e949fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e949fbc",
  null
  
)

export default component.exports